/* unplugin-vue-components disabled */import script from "./utility-product-brand-index.vue?vue&type=script&lang=js"
export * from "./utility-product-brand-index.vue?vue&type=script&lang=js"

import "./utility-product-brand-index.vue?vue&type=style&index=0&id=10e5a746&lang=scss"

const __exports__ = script;

export default __exports__